var _path, _polygon, _path2, _path3, _rect, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f5bc00",
    d: "M44,41H4V10h40V41z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eb7900",
    points: "44,26 24,26 4,26 4,10 44,10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eb7900",
    d: "M17,26h-6v3h6V26z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eb7900",
    d: "M37,26h-6v3h6V26z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 3,
    x: 17,
    y: 7,
    fill: "#f5bc00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#eb0000",
    d: "M17,23h-6v3h6V23z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#eb0000",
    d: "M37,23h-6v3h6V23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBriefcase);
export default __webpack_public_path__ + "static/media/icon-briefcase.b73653ee206b5ad757efdd6b7dcc0922.svg";
export { ForwardRef as ReactComponent };